import type { Sticker } from '../types';

export const olympics: Sticker[] = [
  {
    id: 29001,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/001-cycling.png',
    name: 'Kolarstwo',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29002,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/002-martial-arts.png',
    name: 'Sztuki Walki',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29003,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/003-fencing.png',
    name: 'Szermierka',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29004,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/004-rythmic-gymnastics.png',
    name: 'Gimnastyka Artystyczna',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29005,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/005-weight-lifting.png',
    name: 'Podnoszenie Ciężarów',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29006,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/006-gymnastics.png',
    name: 'Gimnastyka',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29007,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/007-athletism.png',
    name: 'Lekkoatletyka',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29008,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/008-javelin.png',
    name: 'Rzut Oszczepem',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29009,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/009-athletism.png',
    name: 'Bieganie',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29010,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/010-archery.png',
    name: 'Łucznictwo',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29011,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/011-podium.png',
    name: 'Podium',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29012,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/012-basketball.png',
    name: 'Koszykówka',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29013,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/013-olympic-torch.png',
    name: 'Znicz Olimpijski',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29014,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/014-football.png',
    name: 'Piłka Nożna',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29015,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/015-tennis.png',
    name: 'Tenis',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29016,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/016-boxing.png',
    name: 'Boks',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29017,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/017-volleyball.png',
    name: 'Siatkówka',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29018,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/018-table-tennis.png',
    name: 'Tenis Stołowy',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29019,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/019-swimming.png',
    name: 'Pływanie',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 29020,
    url: 'https://stickers.nauczniaczek.pl/colections/14885018-olympics/png/020-waterpolo.png',
    name: 'Piłka Wodna',
    category: 'olympics',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];